import { FC } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import styled, { StyledProps } from 'styled-components'
import { EColorBgText, sv } from '@ucheba/utils/helpers/styles/variables'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import ImgClock from '../assets/img__clock.png'
import ImgMac from '../assets/img__santa.png'
import { ITimerBannerNewYearProps } from '../types'
import ImgElf1 from '../assets/elf_yellow.png'
import ImgElf2 from '../assets/elf_rose.png'
import ImgElf3 from '../assets/elf_white.png'

const Block = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  display: flex;
  border-radius: 8px;
`

const Content = styled.div`
  width: 65%;
  padding: 24px 32px;
`

const ImgWrap = styled.div`
  width: 35%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`

const Img = styled.img`
  max-width: 348px;
  height: auto;
`

const TimeWrap = styled.div`
  border-radius: 4px;
  overflow: hidden;
  width: 262px;
  display: flex;
  justify-content: space-between;
  color: ${sv.color.black};
`

const TimeBlock = styled.div`
  background-color: white;
  width: 64px;
  padding: 8px 4px;
`

const TimeValue = styled.div`
  font-size: ${sv.fontSize.h1};
  font-weight: ${sv.fontWeight.extrabold};
  text-align: center;
  line-height: 1;
`

const Clock = styled.img`
  width: 86px;
`

const Btn = styled.div<StyledProps<any>>`
  background-color: ${(props) => sv.color[props.color]};
  color: ${(props) => sv.color[EColorBgText[props.color]]};
  padding: 20px;
  border-radius: 4px;
  height: 72px;
  margin-right: 8px;
  cursor: pointer;
`

const ListImg = styled.img`
  width: 34px;
`

const TimerBannerNewYear: FC<ITimerBannerNewYearProps> = (props) => {
  const {
    seconds,
    hours,
    days,
    minutes,
    onClick,
    show,
    buttonText,
    title,
    subTitle,
    classValue,
  } = props

  const content = {
    title,
    price: subTitle,
    list: [
      {
        text:
          classValue === '10' ? '15 месяцев</br> обучения' : '5 месяцев</br> обучения',
        img: ImgElf1,
      },
      {
        text: classValue === '9' ? 'последние</br> места' : 'гарантия</br> поступления',
        img: ImgElf2,
      },
      {
        text: 'беспроцентная</br> рассрочка',
        img: ImgElf3,
      },
    ],
  }

  return (
    <Block color='black'>
      <Content>
        <Heading h2={content.title} spacing='large' color='white' />

        <Grid spacing='uxsmall'>
          <GridCol width='auto'>
            <Text fontSize='h2' lineHeight='h2' color='gold'>
              {content.price}
            </Text>
          </GridCol>
        </Grid>

        <Spacing spacing='large' />

        <Grid spacing='large'>
          {content.list.map((item, key) => {
            return (
              <GridCol width='auto' key={key}>
                <div
                  style={{
                    display: 'flex',
                  }}
                >
                  <div
                    style={{
                      marginRight: '8px',
                    }}
                  >
                    <ListImg src={item.img} />
                  </div>

                  <div>
                    <Text
                      fontSize='large'
                      lineHeight='large'
                      fontWeight='semibold'
                      color='white'
                    >
                      {item.text}
                    </Text>
                  </div>
                </div>
              </GridCol>
            )
          })}
        </Grid>

        <Spacing spacing='xlarge' />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {onClick && (
            <Btn onClick={onClick} color='gold'>
              <Text fontSize='h3' lineHeight='h3' fontWeight='semibold'>
                {buttonText || 'Хочу записаться!'}
              </Text>
            </Btn>
          )}

          {show && (
            <TimeWrap>
              <TimeBlock>
                <TimeValue>{days}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(days), 'день', 'дня', 'дней')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{hours}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(hours), 'час', 'часа', 'часов')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{minutes}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  {p11n(Number(minutes), 'минута', 'минуты', 'минут')}
                </Text>
              </TimeBlock>

              <TimeBlock>
                <TimeValue>{seconds}</TimeValue>

                <Text
                  textAlign='center'
                  color='gray40'
                  fontSize='xsmall1'
                  lineHeight='xsmall1'
                >
                  секунд
                </Text>
              </TimeBlock>
            </TimeWrap>
          )}

          {!onClick && (
            <div>
              <Clock src={ImgClock} />
            </div>
          )}
        </div>
      </Content>

      <ImgWrap>
        <Img src={ImgMac} />
      </ImgWrap>
    </Block>
  )
}

export default TimerBannerNewYear
